import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MessagesRoutingModule } from './messages-routing.module';
import { ViewMessagesComponent } from './view-messages/view-messages.component';
import { MessageHomeComponent } from './message-home/message-home.component';
import { MatControlsModule } from '../MatControls.module';
import { MessageInboxComponent } from './message-inbox/message-inbox.component';
import { PatientRequestInformationComponent } from './patient-request-information/patient-request-information.component';
import { DisplayMessagesComponent } from './display-messages/display-messages.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedHeaderModule } from '../SharedHeaders.module';
import { PPInsuranceRequestComponent } from '../patient-portal/pp_InsuranceRequest/pp-insurance-request/pp-insurance-request.component';
import { PPBookAppointmentComponent } from '../patient-portal/ppbook-appointment/ppbook-appointment.component';
import { PPDemographicsRequestComponent } from '../patient-portal/ppdemographics-request/ppdemographics-request.component';
import { PPEmergencyRequestComponent } from '../patient-portal/ppemergency-request/ppemergency-request.component';
import { DirectMessagesComponent } from './direct-messages/direct-messages.component';
import { DmProviderSearchComponent } from './dm-provider-search/dm-provider-search.component';
import { TasksandMessagesComponent } from './tasksand-messages/tasksand-messages.component';
// import { TasksandmessagesTabComponent } from './tasksandmessages-tab/tasksandmessages-tab.component';
import { TaskmessagesnewtaskComponent } from './taskmessagesnewtask/taskmessagesnewtask.component';
import { MessagesReplayForwardComponent } from './messages-replay-forward/messages-replay-forward.component';
import { PatientMessengerComponent } from './patient-messenger/patient-messenger.component';
import { TaskmessagesviewComponent } from './taskmessagesview/taskmessagesview.component';
import { PatientAmmendmentsNoteComponent } from '../patient-portal/patient-ammendments-note/patient-ammendments-note.component';
import { ViewAmmendmentsNotesComponent } from '../patient-portal/patient-ammendments-note/view-ammendments-notes/view-ammendments-notes.component';
import { PatientSecureMessagesComponent } from './patient-secure-messages/patient-secure-messages.component';
import { ViewzipfilesComponent } from './direct-messages/viewzipfiles/viewzipfiles.component';

console.warn('Md4Emr lazy Load of Messages Module');

@NgModule({
  declarations: [
    ViewMessagesComponent,
    MessageHomeComponent,
    MessageInboxComponent,
    PatientRequestInformationComponent,
    DisplayMessagesComponent,
    PPInsuranceRequestComponent,
    PPBookAppointmentComponent,
    PPDemographicsRequestComponent,
    PPEmergencyRequestComponent,
    DirectMessagesComponent,
    DmProviderSearchComponent,
    TasksandMessagesComponent,
    // TasksandmessagesTabComponent,
    //TaskmessagesnewtaskComponent,
    //TaskmessagesviewComponent,
    //MessagesReplayForwardComponent,
    PatientMessengerComponent,
    PatientAmmendmentsNoteComponent,
    ViewAmmendmentsNotesComponent,
    ViewzipfilesComponent,
    // PatientSecureMessagesComponent
  ],
  imports: [
    CommonModule,
    MessagesRoutingModule,
    MatControlsModule,
    FormsModule, ReactiveFormsModule, SharedHeaderModule,
  ],
  entryComponents: [
    ViewzipfilesComponent
    //TaskmessagesnewtaskComponent,
    //TaskmessagesviewComponent,
    //MessagesReplayForwardComponent

  ]
})
export class MessagesModule { }
